<template>
  <div>
    <div style="width: 300px" class="mb-5">
      <search-nav-item-field-select-name label="사업장명" v-model="nav.fieldName" size="small" name="fieldName"/>
    </div>
    <div class="flex items-center gap-4 mb-5">
      <search-nav-item-select label="부서명" v-model="nav.company0" :list="companyDepth0" name="company0" @change="onChange1"/>
      <search-nav-item-select :readonly="!(!!nav.company0 && nav.company0 !== '전체')" label="2차 분류" v-model="nav.company1" :list="companyDepth1" name="company1" @change="onChange2"/>
      <search-nav-item-select :readonly="!(!!nav.company1 && nav.company1 !== '전체')" label="3차 분류" v-model="nav.company2" :list="companyDepth2" name="company2" @change="onChange3"/>
    </div>
    <div class="flex items-center gap-4">
      <search-nav-item-select :label="$t('search.검색조건')" v-model="nav.searchType" :list="searchTypes" name="searchType"/>
      <search-nav-item-keyword :label="$t('search.키워드')" v-model="nav.searchKeyword" />
    </div>
  </div>
</template>

<script>
import SearchNavStartEnd from "@/components/nav/SearchNavStartEnd.vue";
import SearchNav from "@/components/nav/SearchNav";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import SearchNavItemFieldSelectName from "@/components/nav/SearchNavItemFieldSelectWithName.vue";

export default {
  name: "NormalSearchNav433",
  components: {
    SearchNavItemFieldSelectName,
    SearchNavStartEnd,
    SearchNavItemSelect,
    SearchNavItemKeyword,
    SearchNav,
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    companyDepth0() {
      const depth = this.companyTree
        .filter((item) => item.depth === 0)
        .map((item) => {
          return {
            value: item.descendant_id,
            text: item.descendant.com_name,
          };
        });
      return [{ value: null, text: "전체" }, ...depth];
    },
    companyDepth1() {
      if (!!this.nav.company0 && this.nav.company0 !== "전체") {
        const depth = this.companyTree
          .filter((item) => {
            return item.depth === 1 && item.company_path.indexOf(`${this.nav.company0}/`) === 0;
          })
          .map((item) => {
            return {
              value: item.descendant_id,
              text: item.descendant.com_name,
            };
          });
        return [{ value: null, text: "전체" }, ...depth];
      } else {
        return [];
      }
    },
    companyDepth2() {
      if (!!this.nav.company1 && this.nav.company1 !== "전체") {
        const depth = this.companyTree
          .filter((item) => {
            return item.depth === 2 && item.company_path.indexOf(`${this.nav.company0}/${this.nav.company1}/`) === 0;
          })
          .map((item) => {
            return {
              value: item.descendant_id,
              text: item.descendant.com_name,
            };
          });
        return [{ value: null, text: "전체" }, ...depth];
      } else {
        return [];
      }
    },
  },
  watch: {
    nav: {
      immediate: true,
      deep: true,
      handler(value) {
        // watch 에서 watch 의 대상이 되는 변수의 값을 변경하면 무한루프에 빠지게 된다.
        this.$emit("input", this.nav);
      },
    },
  },
  data() {
    return {
      companyTree: [],

      nav: {
        fieldName: "",

        company0: null,
        company1: null,
        company2: null,

        searchType: "",
        searchKeyword: "",
      },
      searchTypes: [
        { value: "ID(사번)" },
        { value: "부서" },
        { value: "업무분야" },
        { value: "직종" },
        { value: "성별" },
        { value: "입사일" },
        { value: "종료 예정일" },
        { value: "핸드폰" },
        { value: "총 교육이수 시간" },
        { value: "행정전화" },
        { value: "종료일" },
      ],
    };
  },
  async created() {
    await this.$store.dispatch("company/LOAD_COMPANY_TREE", { projectId: this.projectId, new: true }).then((result) => {
      this.companyTree = result;
    });
  },
  methods: {
    onChange1 (value1) {
      if (!value1) {
        this.nav.company1 = null;
        this.nav.company2 = null;
      }
    },
    onChange2 (/*value2*/) {
      this.nav.company2 = null;
    },
    onChange3 (value3) {

    }
  }
};
</script>

<style scoped></style>
